export const Constants = {
  // API URLs
  PY_API_URL: process.env.REACT_APP_PY_API_URL || "http://192.168.1.83:8000/",
  
  // API Version
  API_VERSION: process.env.REACT_APP_API_VERSION || "1.0",
  
  // Static masterdetailId (you can change this as needed)
  MASTER_DETAIL_ID: process.env.REACT_APP_MASTER_DETAIL_ID || "81730528-4783-49cd-bd01-b5fa76294450",
  
  // User logged by details (static values)
  USER_LOGGED_BY: process.env.REACT_APP_USER_LOGGED_BY || "admin",
  USER_LOGGED_BY_CODE: process.env.REACT_APP_USER_LOGGED_BY_CODE || "414417",
  
  // Registration constants
  IS_REGISTERED: parseInt(process.env.REACT_APP_IS_REGISTERED || "1"),
  ADMIN_CREATED: parseInt(process.env.REACT_APP_ADMIN_CREATED || "1"),
};

export default Constants; 